<form [formGroup]="form" *ngIf="formGenerated">
  <scitis-app-global-page-header [pageTitle]="'Cloudplug Light General Settings'">

    <ng-template #filterElement>
          <button (click)="onSave()" [disabled]="form.invalid || !isAdminOrSuperAdminOrTechAdmin"
                  class="btn btn-primary"
                  [title]="'Save'|translate"
                  type="button">
          <span>
            <span class="fa-solid fa-check"></span>
            <span translate>Save</span>
          </span>
          </button>
    </ng-template>

    <ng-template #filterElement>
          <button (click)="onPushToIotCore()" [disabled]="form.invalid || !isAdminOrSuperAdminOrTechAdmin"
                  class="btn btn-outline-primary"
                  [title]="'Send configuration'|translate"
                  type="button">
          <span>
            <span class="fa-solid fa-cloud-arrow-up"></span>
            <span translate>Send configuration</span>
          </span>

          </button>
    </ng-template>
  </scitis-app-global-page-header>

  <div class="card mb-3">
    <div class="card-body">
      <div [className]="{'has-error': form.invalid, 'has-success': !form.invalid}"
           class="form-group">
        <label for="interval" translate>
          <span translate>Upload interval in seconds</span>
          [<span [innerText]="UPLOAD_INTERVAL_MIN"></span> - <span [innerText]="UPLOAD_INTERVAL_MAX"></span>]
          <label>*</label>
        </label>
        <div class="input-group">
          <input [ngClass]="{ 'is-invalid': formControls.interval.errors }" class="form-control"
                 formControlName="interval" id="interval" [max]="UPLOAD_INTERVAL_MAX" [min]="UPLOAD_INTERVAL_MIN"
                 name="interval" type="number">
          <div class="input-group-append">
            <span class="input-group-text">s</span>
          </div>
          <div *ngIf="formControls.interval.errors" class="invalid-feedback">
            <span translate>invalid upload interval!</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</form>
